/**
 * @description: 预定详情(25-04-22)
 * @author: lyr
 */
<template>
	<div class="reserve-detail">
		<div class="page-tit">预定详情</div>
		<div class="wrapper clearfix">
			<div class="col-md-5">
				<label class="col-md-3">门店：</label>
				<span class="col-md-9">{{ detail.shop_name }}</span>
				<label class="col-md-3">预定号：</label>
				<span class="col-md-9">{{ detail.book_no }}</span>
				<label class="col-md-3">客户姓名：</label>
				<span class="col-md-9">{{ detail.customer_name }}</span>
				<label class="col-md-3">客户电话：</label>
				<span class="col-md-9">{{ detail.customer_contact }}</span>
				<label class="col-md-3">预定到店时间：</label>
				<span class="col-md-9">{{ detail.book_time }}</span>
				<label class="col-md-3">到店人数：</label>
				<span class="col-md-9">{{ detail.customer_num }}</span>
				<label class="col-md-3">备注：</label>
				<span class="col-md-9">{{ detail.remark }}</span>
			</div>
			<div class="col-md-5">
				<label class="col-md-3">预定时间：</label>
				<span class="col-md-9">{{ detail.create_time }}</span>
				<label class="col-md-3">包厢区域：</label>
				<span class="col-md-9">{{ detail.room_area_name }}</span>
				<label class="col-md-3">包厢类型：</label>
				<span class="col-md-9">{{ detail.room_type_name }}</span>
				<label class="col-md-3">包厢号：</label>
				<span class="col-md-9">{{ detail.room_name }}</span>
				<label class="col-md-3">预定员工：</label>
				<span class="col-md-9">{{ detail.book_admin_name }}</span>
				<label class="col-md-3">状态：</label>
				<span class="col-md-9">{{ detail.status_name }}</span>
			</div>
		</div>
		<div class="book-det-oper">
			<div class="title" style="margin-bottom: 30px;">操作日志</div>
			<div class="table-responsive" style="padding: 0;margin-bottom:30px">
				<table id="oper_table" class="table table-bordered table-hover" data-pagination="true" ref="oper_table">
				</table>
			</div>
		</div>
		<div>
			<button type="button" class="btn btn-flat btn-middle btn-border-gray"
				@click="$emit('backReservePre')">返回</button>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	export default {
		name: 'reserveDetail',
		data() {
			return {
				detail: {},
				theOpers: [],
			};
		},
		mounted() {
			
		},
		methods: {
			// 获取订单详情
			getBookDetail: function (id) {
				const _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Book/getBookDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function (data) {
						_this.detail = data.response.result;
						// 操作日志
						_this.theOpers = data.response.result.operation_log;
						if (_this.theOpers.length == 0) {
							$('.book-det-oper').hide();
						} else {
							$(_this.$refs.oper_table).bootstrapTable("destroy");
							_this.innitOperTable();
							$('.book-det-oper').show();
						}
					},
					error: function (err) {
						layer.msg("出错啦");
					}
				});
			},

			// 初始化订单详情操作表格
			innitOperTable: function () {
				let _this = this;
				$(_this.$refs.oper_table).bootstrapTable({
					pagination: false,
					columns: [{
						field: "create_time",
						title: "操作时间",
						width: "33%"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "33%"
					}, {
						field: "content",
						title: "详情",
						width: "33%"
					}],
					data: _this.theOpers
				});
			},
		},
	}
</script>
<style lang="less">
	.reserve-detail {
		.wrapper {
			margin: 20px 0 40px;
		}
		.title {
			height: 20px;
			width: 100%;
			margin: 30px 0 30px 0px;
			line-height: 20px;
			font-size: 18px;
		}
		.col-md-5 {
			padding-left: 0;
			font-size: 14px;
			>label {
				height: 40px;
				line-height: 40px;
				padding: 0;
				margin-bottom: 0px;
			}
			>span {
				min-height: 40px;
				padding-left: 0;
				margin: 9px 0 0;
				line-height: 23px;
			}
		}
	}
</style>
